import React from 'react';
import {
  Routes,
  Route,
  Link,
  useMatch,
  useResolvedPath
} from "react-router-dom";
import { Box, Flex } from 'rebass';

import ColorList from './views/ColorList';
import Outline from './views/Outline';
import DeepNested from './views/DeepNested';
import FormView from './views/FormView';

function CustomLink({ children, to, ...props }) {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: true });

  return (
    <Box
      as={Link}
      to={to}
      {...props}
      px={3}
      mr={1}
      py={2}
      css={`
        border-radius: 8px;
        color: ${match ? 'var(--text-alt)' : 'var(--text)'};
        text-decoration: none;
        cursor: pointer;

        &:hover {
          background: var(--borderTransparent);
        }

        ${match ? `
          background: white;
          color: black;
          &:hover {
            background: #ccc;
          }
        ` : ''};
      `}
    >
      {children}
    </Box>
  );
}

function App() {
  const [showDebug, setShowDebug] = React.useState(false);
  const [shouldAnimate, setShouldAnimate] = React.useState(false);

  const pages = [
    {
      name: 'Form view',
      path: '/',
      component: <FormView showDebug={showDebug} shouldAnimate={shouldAnimate} />,
    },
    {
      name: 'Colors',
      path: '/colors',
      component: <ColorList showDebug={showDebug} shouldAnimate={shouldAnimate} />,
    },
    {
      name: 'Outline',
      path: '/outline',
      component: <Outline showDebug={showDebug} shouldAnimate={shouldAnimate} />
    },
    {
      name: 'Deep nested list',
      path: '/deepnestedlist',
      component: <DeepNested showDebug={showDebug} shouldAnimate={shouldAnimate} />
    },
  ];

  return (
    <Box
      className="App"
      css={`
        .border {
          display: ${showDebug ? 'block' : 'none'};
        }
      `}
    >
      <Flex
        as="header"
        justifyContent="space-between"
        alignItems="center"
        p={3}
        css={`
          width: 100%;
          background: var(--background-alt);
          position: fixed;
          z-index: 1;
        `}
      >
        <Flex alignItems="center">
          {pages.map(page => (
            <CustomLink
              key={page.path}
              to={page.path}
            >
            {page.name}</CustomLink>
          ))}
        </Flex>
      </Flex>
      <Box p={5} pt={6}>
        <Routes>
          {pages.map(page => (
            <Route index={page.index} key={page.path} path={page.path} element={page.component} showDebug={showDebug} />
          ))}
        </Routes>
      </Box>
    </Box>
  );
}

export default App;
